import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';

import { useActions } from '@mssgme/hooks';
import { useEnhancedFormik, Button, FormField, FieldError } from '@mssgme/ui';
import { LegaliseSection } from '../../../UI';

export default function RegistrationFormMember({ code, invite }) {
    const { t } = useTranslation();
    const { api } = useActions();
    const formik = useEnhancedFormik({
        initialValues: {
            email: invite.email,
            name: '',
            password: '',
        },
        onSubmit: useCallback((values) => api.users.join({ payload: { ...values, code } }), [code]),
    });

    if (formik.status === 'success') {
        return <Redirect to="/" />;
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            {formik.errors.code && <FieldError>{formik.errors.code}</FieldError>}

            <FormField
                placeholder={t('label.email')}
                type="email"
                autoComplete="email"
                error={t(formik.errors.email)}
                {...formik.getFieldProps('email')}
            />
            {/*<FormField*/}
            {/*    placeholder={t('label.name')}*/}
            {/*    type="text"*/}
            {/*    autoComplete="name"*/}
            {/*    autoFocus*/}
            {/*    error={t(formik.errors.name)}*/}
            {/*    {...formik.getFieldProps('name')}*/}
            {/*/>*/}
            <FormField
                placeholder={t('label.password')}
                type="password"
                autoComplete="new-password"
                error={t(formik.errors.password)}
                {...formik.getFieldProps('password')}
            />
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 30 }}>
                <Button type="submit" fullWidth isFetching={formik.isSubmitting}>
                    {t('RegistrationFormMember.button')}
                </Button>
            </div>

            <LegaliseSection />
        </form>
    );
}

RegistrationFormMember.propTypes = {
    code: PropTypes.string.isRequired,
    invite: PropTypes.shape({
        email: PropTypes.string.isRequired,
    }).isRequired,
};
